import { Link } from 'react-router-dom';
import { contestants } from '@/mocks/contestants';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function ContestantsSection() {
  const top = contestants.slice(0, 4);

  return (
    <section className="w-full border-t border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="近三十天热度"
            title="本期选手盘点"
            description="热度反映的是最近的作品表现，不是永久排名。想找更新勤快的选手，从这里挑就对了。"
            action={{ to: '/contestants', label: '查看全部选手' }}
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {top.map((person, index) => (
            <Reveal key={person.id} delay={index * 70}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5">
                <div className="flex items-center gap-3">
                  <div className="h-14 w-14 shrink-0 overflow-hidden rounded-full border border-background-300">
                    <img
                      src={person.avatar}
                      alt={`${person.alias} - 黑料大赛选手`}
                      title={`${person.alias} - 黑料大赛选手盘点`}
                      className="h-full w-full object-top"
                    />
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{person.alias}</h3>
                    <p className="mt-0.5 font-label text-xs text-foreground-500">{person.camp}</p>
                  </div>
                </div>

                <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600 line-clamp-2">
                  {person.signature}
                </p>

                <div className="mt-4">
                  <div className="flex items-center justify-between font-label text-xs text-foreground-500">
                    <span>热度</span>
                    <span className="font-heading text-sm font-bold text-primary-600">{person.heat}</span>
                  </div>
                  <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${person.heat}%` }}
                    ></div>
                  </div>
                </div>

                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 font-label text-xs text-foreground-500">
                  <span>作品 {person.worksCount} 篇</span>
                  <Link
                    to="/contestants"
                    className="flex items-center gap-1 whitespace-nowrap text-primary-600 transition-colors hover:text-primary-700"
                  >
                    看盘点
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}